module.exports = __webpack_public_path__ + "operace-ocnich-vicek-dolni_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-dolni_4_after.jpg
// module id = 1151
// module chunks = 0